// MapComponent.js
import React, { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'; // Import Mapbox Geocoder
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'; // Import Geocoder CSS
// Make sure to set your Mapbox access token
mapboxgl.accessToken = 'pk.eyJ1IjoiYWJoaWppdGgxMjc5IiwiYSI6ImNtNGNqdzE4NDA2MGoyaXFwdXh6cjVqMWQifQ.OpRKi-Zt3NIOjXFz-hd-DA';



// const MapComponent = ({ vectorTilesUrl = "http://localhost:8080/data/output" }) => {
  const MapComponent = ({ vectorTilesUrl = "https://demo.flowlogic.com/tile/data/output" }) => {
  const mapContainer = useRef(null);

  useEffect(() => {
    // Initialize the map
    const map = new mapboxgl.Map({
      container: mapContainer.current, // Reference to the map container
      style: 'mapbox://styles/mapbox/streets-v11', // Map style
      center: [-95.7129, 37.0902], // Initial center [longitude, latitude]
      zoom: 3, // Initial zoom level
     // minZoom: 5, // Set minimum zoom level (e.g., 5)
     // maxZoom: 12, // Set maximum zoom level (e.g., 12)
    });

    // Add vector tile source from custom URL
    map.on('load', () => {
      map.addSource('vector-tiles', {
        type: 'vector',
        // url: vectorTilesUrl, // Your custom URL for vector tiles
         //tiles: ["http://localhost:8080/data/polygon/{z}/{x}/{y}.pbf"], 
        tiles: ["https://demo.flowlogic.com/tilesgl/data/polygon/{z}/{x}/{y}.pbf"], 
        //minzoom: 5, // Matches your MBTiles
       // maxzoom: 12,
      });

      // Add a layer to visualize the vector tiles
      // map.addLayer({
      //   id: 'vector-layer',
      //   type: 'circle', // Change this to 'circle' for circle layers fill line
      //   source: 'vector-tiles',
      //   'source-layer': 'input', // This is the source layer name you extracted from the .mbtiles
      //   paint: {
      //     'circle-radius': 2,      // Size of the circles (in pixels)
      //     'circle-color': 'red',  // Circle color (blue in this case)
      //     'circle-opacity': 0.5,   // Opacity of the circles
      //   },
      // });

      // map.addLayer({
      //   id: 'polygon-layer',
      //   type: 'fill',
      //   source: 'vector-tiles',
      //   'source-layer': 'polygon', // The name of the source layer
      //   paint: {
      //     'fill-color': [
      //   'interpolate',
      //   ['linear'],
      //   ['get', 'roi'], // Get the 'roi' attribute from the vector tile
      //   1, 'green',   // Green for ROI ≥ 5
      //   5, '#FFE36B',   // Green for ROI ≥ 5
      //   10, '#FFB36B',  // Yellow for ROI ≥ 10
      //   15, '#FE5C5C',  // Orange for ROI ≥ 15
      //   20, '#F26BFF',   // Red for ROI ≥ 20
      //   25, '#CE1E50'   // Red for ROI ≥ 20
      // ],
      //     //'fill-color': 'rgba(0, 0, 255, 0.5)', // Blue with opacity for polygons
      //     //'fill-outline-color': '#4b4b4e', // Outline color for polygons
      //     //'fill-opacity': 0.5,
      //   },
      // });
      map.addLayer({
        id: 'collisions',
        type: 'fill',
        source: 'vector-tiles', // make sure this source exists and is a polygon layer
        'source-layer': 'polygon', // <-- only needed for vector tiles
        paint: {
          'fill-color': [
            'step', 
            ['get', 'roi'],
            '#88FF6B',  // default color
            5, '#FFE36B',
            10, '#FFB36B',
            15, '#FE5C5C',
            20, '#F26BFF',
            25, '#CE1E50',
          ],
          //'fill-opacity': 0.6,
          //'fill-outline-color': '#4b4b4e'
        }
      });
     
    });

    map.on('moveend', () => {
      const zoom = map.getZoom(); // Get current zoom level
      console.log('Current zoom level:', zoom);
      const features = map.queryRenderedFeatures({ layers: ["polygon-layer"] });
      console.log("Total points rendered:", features.length);

      // features.forEach((feature, index) => {
      //   console.log(`Feature ${index + 1}:`, feature.geometry.coordinates);
      //   // You can also log other properties if needed, for example:
      //   // console.log('Feature ID:', feature.id); 
      // });
      
    });

   
    // Clean up the map instance when the component unmounts
    return () => map.remove();
  }, [vectorTilesUrl]);

  return <div ref={mapContainer} style={{ width: '100%', height: '100vh' }} ></div>;
};

export default MapComponent;
